import React from 'react';
import MetaIdTypeaheadField from './MetaIdTypeaheadField';
import {
  searchMetaCustomAudiences,
  getMetaCustomAudiencesByIds,
} from '../../../shared/budgetApi';

/**
 * MetaCustomAudienceField
 *
 * Custom Audience ID row: typeahead over active audiences
 * (delivery_status.code === 200) with the audience name shown to the right.
 */
const MetaCustomAudienceField = props => (
  <MetaIdTypeaheadField
    {...props}
    searchFn={searchMetaCustomAudiences}
    lookupFn={getMetaCustomAudiencesByIds}
    noResultsMessage="No active audiences found"
    unknownLabel="Unknown audience"
  />
);

export default MetaCustomAudienceField;
